var exports = {};

function isInput(elem) {
  return elem && elem.nodeName && elem.nodeName.toLowerCase() === "input";
}

exports = isInput;
export default exports;